import { render, staticRenderFns } from "./app-detail-game-card.vue?vue&type=template&id=5bf401f7&scoped=true&"
import script from "./app-detail-game-card.vue?vue&type=script&lang=js&"
export * from "./app-detail-game-card.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-game-card.vue?vue&type=style&index=0&id=5bf401f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf401f7",
  null
  
)

export default component.exports